var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShapeTurquoise = function SvgShapeTurquoise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shapeTurquoise_svg__Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.41 94.6"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shapeTurquoise_svg__clip-path",
    transform: "translate(-2.29 -5.11)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "shapeTurquoise_svg__cls-1",
    d: "M2.07 4.34h101v96h-101z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "shapeTurquoise_svg__clip-path-2",
    transform: "translate(-2.29 -5.11)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "shapeTurquoise_svg__cls-1",
    transform: "rotate(-71.84 56.392 54.533)",
    d: "M5.77 5.78h101.25v97.5H5.77z"
  })), /*#__PURE__*/React.createElement("style", null, ".shapeTurquoise_svg__cls-1{fill:none}.shapeTurquoise_svg__cls-3{clip-path:url(#shapeTurquoise_svg__clip-path-2)}"))), /*#__PURE__*/React.createElement("g", {
    className: "shapeTurquoise_svg__cls-3",
    style: {
      clipPath: "url(#shapeTurquoise_svg__clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.35 67.07c1.33-10.18-1.22-20.34-4.85-29.81-3.21-8.35-7.64-16.34-14.11-22.61-3.12-3.05-6.77-6.1-10.86-7.65a27.91 27.91 0 0 0-12.87-1.7A27.53 27.53 0 0 0 47.2 9.52c-4.21 2.71-7.33 6.6-10.52 10.41-7.21 8.66-16.2 15.59-23.49 24.22C6.73 51.78 1.7 61.24 2.35 71.54 3 81.38 9.49 89 17.87 93.66c9.6 5.26 20.85 6.65 31.66 5.83A111.34 111.34 0 0 0 65.63 97a160.87 160.87 0 0 0 15.63-4.1 29.92 29.92 0 0 0 12.38-7.23 31.41 31.41 0 0 0 7.16-11.91 38.56 38.56 0 0 0 1.55-6.69",
    transform: "translate(-2.29 -5.11)",
    style: {
      fill: "#3edad8"
    },
    className: "shapeTurquoise_svg__cls-3"
  })));
};
export default SvgShapeTurquoise;